var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-data-table',{attrs:{"caption":"Платежи","headers":_vm.headers,"items":_vm.preparedItems,"highlight-last-row":true}})}
var staticRenderFns = []

export { render, staticRenderFns }